'use strict';
import isNumber from 'lodash/isNumber';
import isObject from 'lodash/isObject';


/**
 * @param {?ActiveTimer#interval} o1
 * @param {?ActiveTimer#interval} o2
 * @return {*}
 */
export function intervalComparator(o1, o2) {
  /** @type {?ActiveTimer#interval} */
  const a = isObject(o1) ? o1 : null;
  /** @type {?ActiveTimer#interval} */
  const b = isObject(o2) ? o2 : null;

  const aStart = a !== null && isNumber(a.start) ? a.start : null;
  const bStart = b !== null && isNumber(b.start) ? b.start : null;

  const start = compareTime(aStart, bStart);

  if (start !== 0) {
    return start;
  } else {
    const aEnd = a !== null && isNumber(a.end) ? a.end : null;
    const bEnd = b !== null && isNumber(b.end) ? b.end : null;

    return compareTime(aEnd, bEnd);
  }
}

export function compareTime(a, b) {
  const aN = isNumber(a);
  const bN = isNumber(b);

  if (!aN && !bN) {
    return 0;
  } else if (aN && !bN) {
    return -1;
  } else if (!aN && bN) {
    return 1;
  } else {
    return compareNumber(a, b);
  }
}

/**
 * @param {Number} x
 * @param {Number} y
 * @return {Number}
 */
export function compareNumber(x, y) {
  return (x < y) ? -1 : ((x === y) ? 0 : 1);
}

/**
 * Null-safe Math.max.
 * @param {?Number} a
 * @param {?Number} b
 * @return {?Number}
 */
export function max(a, b) {
  const aN = isNumber(a);
  const bN = isNumber(b);

  if (!aN && !bN) {
    return null;
  } else if (aN && !bN) {
    return a;
  } else if (!aN && bN) {
    return b;
  } else {
    return Math.max(a, b);
  }
}

/**
 * @param {?ActiveTimer#GPSEntry} o1
 * @param {?ActiveTimer#GPSEntry} o2
 * @return {*}
 */
export function locationComparator(o1, o2) {
  /** @type {?ActiveTimer#GPSEntry} */
  const a = isObject(o1) ? o1 : null;
  /** @type {?ActiveTimer#GPSEntry} */
  const b = isObject(o2) ? o2 : null;

  const aTime = a !== null && isNumber(a.tim) ? a.tim : null;
  const bTime = b !== null && isNumber(b.tim) ? b.tim : null;

  return compareTime(aTime, bTime);
}



// WEBPACK FOOTER //
// ./src/js/timers/utils/comparators.js